import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const passwordService = (action: any) => {
  const putPassWordData = {
    member_id: action.memberID,
    password: action.password,
  };

  return {
    putPassword: () => apiClient.put(`${API_BASE_ADDRESS}/mypage/member/password`, putPassWordData),
    getPasswordStatus: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/member/${action.memberID}/password/status`),
  };
};

export default passwordService;
